/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import descriptor from 'solis/claude/action/descriptor/update.rule';
import ActionCard from 'solis/claude/action/card';
import Field from 'solis/claude/action/field';

import ZoneRuleType from 'solis/claude/action/enum/zone.rule.type';

import BoundSegmentedControl from 'solis/navigation/input/segmented.control';
import BoundSlider from 'solis/navigation/input/slider';


const RULE_TYPE_OPTIONS =
[
  { value: ZoneRuleType.Incentive, label: 'Incentive' },
  { value: ZoneRuleType.Penalty,   label: 'Penalty' },
];

const VALUE_MIN = 0;
const VALUE_MAX = 10;


export default ({ context }) =>
(
  <ActionCard label = 'Update zone rule' descriptor = {descriptor} context = {context}>

    <Field label = 'Rule type'>
      <BoundSegmentedControl scope = {descriptor.scope} name = 'ruleType' initial = {descriptor.inputs.ruleType} options = {RULE_TYPE_OPTIONS} />
    </Field>

    <Field label = 'Value'>
      <BoundSlider scope = {descriptor.scope} name = 'ruleValue' initial = {descriptor.inputs.ruleValue} min = {VALUE_MIN} max = {VALUE_MAX} />
    </Field>

  </ActionCard>
);
